import { render, staticRenderFns } from "./TxtImgCardWidget.vue?vue&type=template&id=4700568e&"
import script from "./TxtImgCardWidget.vue?vue&type=script&lang=js&"
export * from "./TxtImgCardWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\DIA-funsporthandel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4700568e')) {
      api.createRecord('4700568e', component.options)
    } else {
      api.reload('4700568e', component.options)
    }
    module.hot.accept("./TxtImgCardWidget.vue?vue&type=template&id=4700568e&", function () {
      api.rerender('4700568e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/widgets/TxtImgCardWidget.vue"
export default component.exports